import { render, staticRenderFns } from "./SaveTransaction.vue?vue&type=template&id=40d9311e"
import script from "./SaveTransaction.vue?vue&type=script&lang=js"
export * from "./SaveTransaction.vue?vue&type=script&lang=js"
import style0 from "./SaveTransaction.vue?vue&type=style&index=0&id=40d9311e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports